var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 452.328,
    viewBox: "0 0 512 452.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(-160.919 -3173.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M635.563,3218.312a129.738,129.738,0,0,0-98.644-44.434c-53.948,0-88.1,32.22-107.255,59.25a196.337,196.337,0,0,0-12.745,20.665,196.174,196.174,0,0,0-12.745-20.665c-19.152-27.03-53.307-59.25-107.255-59.25a129.743,129.743,0,0,0-98.645,44.435c-24.088,27.334-37.355,63.942-37.355,103.08,0,42.6,16.633,82.228,52.345,124.7,31.917,37.96,77.834,77.088,131.005,122.4,19.813,16.884,40.3,34.344,62.115,53.429l.655.574a15,15,0,0,0,19.76,0l.655-.574c21.813-19.085,42.3-36.544,62.118-53.431,53.168-45.306,99.085-84.434,131-122.4,35.712-42.473,52.345-82.1,52.345-124.7C672.919,3282.255,659.652,3245.647,635.563,3218.312ZM470.112,3545.656c-17.08,14.554-34.658,29.533-53.193,45.646-18.534-16.111-36.113-31.091-53.2-45.648-104.059-88.673-172.8-147.254-172.8-224.261,0-31.83,10.6-61.394,29.862-83.245a100.131,100.131,0,0,1,76.138-34.27c41.129,0,67.716,25.338,82.776,46.594a177.836,177.836,0,0,1,22.962,45.659,15,15,0,0,0,28.524,0,177.852,177.852,0,0,1,22.962-45.66c15.06-21.255,41.647-46.593,82.776-46.593a100.127,100.127,0,0,1,76.137,34.27c19.258,21.851,29.863,51.415,29.863,83.245C642.919,3398.4,574.174,3456.981,470.112,3545.656Z",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.656c10b28fb33c5fe4c9a91e563bc66b.svg";
export { ForwardRef as ReactComponent };